import  React, {
        useState, 
        useEffect, 
        useRef, 
        useMemo, 
        useCallback
        }                                   from "react";
import { createPortal }                     from "react-dom";
import  Style                               from "components/UI/main.module.scss";
import  {   getFeedBackList,
            getFeedBackByID,
            updateFeedBack,
            getUserMentorsByID,
            getLastUserFeedBack,
            getFeedBackHistoryList,
        }                                   from "./feedBackService";
import  {   GetSystemLabel,
            GetBusinessLabel,
            GetAppLang,
            Spinner,
            IsMentor,
        }                                   from "Utilities/utils";   
import  {
            getApplicationContentList,
            getDevelopmentStageList,
        }                                   from "../Content/contentService"
import {    getDepartmentAssignmentList,
            getAssignmentList,
            getDepartmentList,            
       }                                    from "Pages/Users/usersService";
import {    DisplayGridDatetime,
            DisplayGridDate,
            DateFromIsoString,
            getDateNow,
            compareInitFinDate,
       }                                    from "components/Date/date"
import { useModal }                         from "components/Covers/genericModal";
import { useSideContent }                   from "components/SideContent/sideContent";
import { useToastMessage}                   from "components/Covers/toastMessage";
import { ModalContent,
       }                                    from "components/Modal/modal";
import { TableGrid}                         from "components/Table/table";
import { AppContentList}                    from "Pages/ContentScript/content_script_pg";
import  {   FeedBackForm,
            FeedBackDocument,
        }                                   from "./FeedBackForm";
import  {   CustomBtn,
            FloatBtn,
            RefreshBtn,
        }                                   from "components/Button/button";
import { FloatingContainer }                from "components/Container/floatContainer";
import { BtnCloseAction     }               from "components/Buttons/Close/BtnClose";
import { AccessDeniedContent } from "components/Content/accessContent";
import  {   useEditDraftAutoSave,
            takeEditDraft,
            clearEditDraft,
        }                                   from "Utilities/editDraft";

const buildFeedBackDraftKey     = (o) => `FeedBackEdit-${o?.FeedBackId || 0}-${o?.CycleId ?? 0}-${o?.CyclePeriodId ?? 0}-${o?.MenteeId ?? 0}`;

const blank_feedback_obj        = {
    NeedSave                : false,
    CycleId                 : 0,
    CyclePeriodId           : 0,
    FeedBackId              : 0,
    MentorId                : 0,
    MenteeId                : 0,
    StatusId                : 1,
    FillStatusId            : 0,
    DevelopmentStageId      : null,
    DepartmentId            : null,
    AssignmentId            : null,
    EmployeeFeedBack        : "",
    ManagerFeedBack         : "",
    DevelopmentPlan         : "",
    NextSteps               : "",
    FeedBackDate            : "",
    ManagerPrivateNotes     : "",
};

const formatMessages            = ({messageHeader, messageVector}) => {
    return (
        <React.Fragment>
            <div>
                <span className={[Style.fw_semibold, Style.fs_6].join(" ")}>
                    {messageHeader}
                </span>
            </div>
            <div>
                {messageVector.map((msg, i) => (
                    <React.Fragment key={i}>
                        <div className={Style.my_3}>
                            <span className={[Style.text_body, Style.fs_8, Style.my_3,].join(" ")}>
                                {i + 1} : {msg}<br/>
                            </span>
                        </div>
                    </React.Fragment>
                ))}
            </div>
        </React.Fragment>
    );
};

const isMobileOrTablet = () => {
    const userAgent = navigator.userAgent || window.opera;
    const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const isSmallScreen = window.innerWidth <= 768;

    return /android|ipad|iphone|ipod/i.test(userAgent) || (isTouch && isSmallScreen);
};

const ExportContextLabel        = ({includePrivate, includeStage}) => {
    if (includePrivate === true) {
        return includeStage === true ? GetBusinessLabel("FeedbackFormLabel16") : GetBusinessLabel("FeedbackFormLabel15");
    }
    return includeStage === true ? GetBusinessLabel("FeedbackFormLabel13") : GetBusinessLabel("FeedbackFormLabel14");
};

const ExportToggleOption        = ({label, value, onChange}) => {
    const optionClass = (isActive) => [Style.d_flex,
                                        Style.align_items_center,
                                        Style.justify_content_center,
                                        Style.clickable,
                                        isActive ? Style.info_bg : Style.vanilla_bg,
                                        Style.rounded_3,
                                        Style.border,
                                        Style.shadow_sm,
                                        Style.m_1,
                                        Style.py_2,
                                        Style.px_4,
                                        Style.pop_item_animation].join(" ");
    return (
        <div className={Style.mb_2}>
            <div className={[Style.d_flex, Style.justify_content_center, Style.align_items_center].join(" ")}>
                <span className={[Style.fs_8, Style.text_body].join(" ")}>{label}</span>
            </div>
            <div className={[Style.d_flex, Style.justify_content_center, Style.align_items_center].join(" ")}>
                <div    className={optionClass(value === true)}
                        style={{width: "30%"}}
                        onClick={() => onChange(true)}
                >
                    <span className={[Style.fs_8, Style.text_body].join(" ")}>
                        {GetSystemLabel("Yes")}
                    </span>
                </div>
                <div    className={optionClass(value === false)}
                        style={{width: "30%"}}
                        onClick={() => onChange(false)}
                >
                    <span className={[Style.fs_8, Style.text_body].join(" ")}>
                        {GetSystemLabel("No")}
                    </span>
                </div>
            </div>
        </div>
    );
};

const ExportControls            = React.memo(({coordinate, visible, setVisible, draggable, action}) => {
    const [includePrivate, setIncludePrivate] = useState(false);
    const [includeStage,   setIncludeStage  ] = useState(true);

    useEffect(() => {}, [coordinate, draggable]);
    useEffect(() => {
        if (visible) {
            setIncludePrivate(false);
            setIncludeStage(true);
        }
    }, [visible]);

    return createPortal(
        <FloatingContainer
                Visible={visible}
                Coordinate={{ x: coordinate.x, y: coordinate.y }}
                Width={draggable ? 420 : 320}
                Height={draggable ? 340 : 560}
                Draggable={draggable}
                StackPosition={4}
            >
            <div>
                <div style={{width: '100%'}} className={[   Style.vanilla_bg,
                                    Style.rounded_3,
                                    Style.shadow_sm,
                                    Style.border,
                                    Style.mx_2].join(" ")}
                >
                    <div className={[   Style.clickable,
                                        Style.header_bg,
                                        Style.rounded_top_3].join(" ")}
                    >
                        <div className={Style.row}>
                            <div className={Style.col}>
                                <div className={[Style.text_end, Style.m_1].join(" ")}>
                                    {<BtnCloseAction click_action={() => {setVisible(false);}}/>}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={[ Style.rounded_bottom_3].join(" ")}>
                        <div className={Style.m_3}>
                            <div className={[Style.d_flex, Style.justify_content_center, Style.align_items_center, Style.mb_2].join(" ")}>
                                <span className={[Style.fs_7, Style.fw_semibold, Style.text_body].join(" ")}>{GetBusinessLabel("FeedbackFormLabel10")}</span>
                            </div>

                            <ExportToggleOption
                                label={GetBusinessLabel("FeedbackFormLabel11")}
                                value={includePrivate}
                                onChange={setIncludePrivate}
                            />

                            <ExportToggleOption
                                label={GetBusinessLabel("FeedbackFormLabel12")}
                                value={includeStage}
                                onChange={setIncludeStage}
                            />

                            <div className={[Style.d_flex, Style.justify_content_center, Style.align_items_center, Style.my_2].join(" ")}>
                                <span className={[Style.fs_9, Style.text_body].join(" ")}>
                                    <ExportContextLabel includePrivate={includePrivate} includeStage={includeStage}/>
                                </span>
                            </div>

                            <div className={[Style.d_flex, Style.justify_content_center, Style.align_items_center].join(" ")}>
                                <div    className={[Style.d_flex,
                                                    Style.align_items_center,
                                                    Style.justify_content_center,
                                                    Style.clickable,
                                                    Style.info_bg,
                                                    Style.rounded_3,
                                                    Style.border,
                                                    Style.shadow_sm,
                                                    Style.m_2,
                                                    Style.py_3,
                                                    Style.px_5,
                                                    Style.pop_item_animation].join(" ")}
                                        style={{width: "35%"}}
                                        onClick={() => {
                                            action(includePrivate, includeStage);
                                            setVisible(false);
                                        }}
                                >
                                    <span className={[Style.fs_8, Style.text_body].join(" ")}>
                                        {GetSystemLabel("Export")}
                                    </span>
                                </div>
                                <div    className={[Style.d_flex,
                                                    Style.align_items_center,
                                                    Style.justify_content_center,
                                                    Style.clickable,
                                                    Style.vanilla_bg,
                                                    Style.rounded_3,
                                                    Style.border,
                                                    Style.shadow_sm,
                                                    Style.m_2,
                                                    Style.py_3,
                                                    Style.px_5,
                                                    Style.pop_item_animation].join(" ")}
                                        style={{width: "35%"}}
                                        onClick={() => {
                                            setVisible(false);
                                        }}
                                >
                                    <span className={[Style.fs_8, Style.text_body].join(" ")}>
                                        {GetSystemLabel("Cancel")}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </FloatingContainer>,
        document.body
    );
});

const FormControls              = React.memo(({...props}) => {
    const   { SaveAction,        
              ExitAction,
              DoneAction,
              ExportAction,
              CanEdit,
              Content,
        }                        = props;
    const [visible,    setVisible   ] = useState(false);
    const [coordinate, setCoordinate] = useState({x: 0,y: 0});

    const Draggable        = !isMobileOrTablet();

    const handleDisplay = (e) => {
        if (visible) return;
        const rect = e.currentTarget.getBoundingClientRect();
        if (Draggable) {
            setCoordinate({ x: rect.left, y: rect.bottom - 400});
            setVisible(true);
        }
        else {            
            setCoordinate({ x: 35, y: 350});
            setVisible(true);
        }
    };

    useEffect(() => {}, []);

    return(
        <React.Fragment>
            <div className={[   Style.row,
                                Style.rounded_3,
                                Style.border,
                                Style.card_bg,
                                Style.d_flex,
                                Style.align_items_center,
                                Style.justify_content_end,
                            ].join(" ")}
            >
                <ExportControls visible={visible} setVisible={setVisible} coordinate={coordinate} draggable={Draggable} action={ExportAction}/>
                <div className={[Style.col_lg_2, Style.d_flex, Style.align_items_center, Style.justify_content_center].join(" ")}>
                    <div    className={[Style.d_flex, 
                                        Style.align_items_center, 
                                        Style.justify_content_center,
                                        Style.clickable,
                                        Style.vanilla_bg, 
                                        Style.rounded_3, 
                                        Style.border, 
                                        Style.shadow_sm,                                      
                                        Style.m_2,
                                        Style.py_3,
                                        Style.px_5,
                                        Style.pop_item_animation].join(" ")}      
                            style={{width: "50%"}}
                            onClick={(e) => {
                                handleDisplay(e);
                            }}
                    >
                        <span className={[Style.fs_8, Style.text_body].join(" ")}>
                            {GetSystemLabel("ExportPdf")}
                        </span>                                
                    </div>
                </div>
                <div className={[Style.col_lg_2, Style.d_flex, Style.align_items_center, Style.justify_content_center].join(" ")}>
                    <div    className={[Style.d_flex, 
                                        Style.align_items_center, 
                                        Style.justify_content_center,
                                        Style.clickable,
                                        Style.vanilla_bg, 
                                        Style.rounded_3, 
                                        Style.border, 
                                        Style.shadow_sm,    
                                        Style.m_2,                                  
                                        Style.py_3,
                                        Style.px_5,
                                        Style.pop_item_animation].join(" ")}
                            style={{width: "50%"}}                                                                    
                            onClick={() => {
                                ExitAction();
                            }}
                    >
                        <span className={[Style.fs_8, Style.text_body].join(" ")}>
                            {GetSystemLabel("Cancel")}
                        </span>                                
                    </div>                    
                </div>
                {CanEdit && (
                    <div className={[Style.col_lg_2, Style.d_flex, Style.align_items_center, Style.justify_content_center].join(" ")}>
                        <div    className={[Style.d_flex, 
                                            Style.align_items_center, 
                                            Style.justify_content_center,
                                            Style.clickable,
                                            Style.vanilla_bg, 
                                            Style.rounded_3, 
                                            Style.border, 
                                            Style.shadow_sm,                                      
                                            Style.m_2,
                                            Style.py_3,
                                            Style.px_5,
                                            Style.pop_item_animation].join(" ")}
                                style={{width: "50%"}}                                                                              
                                onClick={() => {SaveAction();}}
                        >
                            <span className={[Style.fs_8, Style.text_body].join(" ")}>
                                {GetSystemLabel("Save")}
                            </span>                                
                        </div>
                    </div>
                )}
                {CanEdit && (
                    Content?.FillStatusId !== 1 ? 
                        <div className={[Style.col_lg_2, Style.d_flex, Style.align_items_center, Style.justify_content_center].join(" ")}>
                            <div    className={[Style.d_flex, 
                                                Style.align_items_center, 
                                                Style.justify_content_center,
                                                Style.clickable,
                                                Style.info_bg,                                                 
                                                Style.rounded_3, 
                                                Style.border, 
                                                Style.shadow_sm,                                      
                                                Style.m_2,
                                                Style.py_3,
                                                Style.px_5,
                                                Style.pop_item_animation].join(" ")}
                                    style={{width: "50%"}}                                                                              
                                    onClick={() => {
                                        DoneAction();
                                    }}
                            >
                                <span className={[Style.fs_8, Style.text_ibody].join(" ")}>
                                    {GetSystemLabel("Save")} {GetSystemLabel("and")} {GetSystemLabel("Finish")}
                                </span>                                
                            </div>
                        </div>
                    :
                        null
                )}
            </div>  
        </React.Fragment>
    );
});

const FeedBackEdit              = ({...setProps}) => {
    // Main props
    const { SearchStatus,
            Content,
            SetContent,
            ShowSideContent,
            ShowModal,
            GetList,
    }                       = setProps;
    // Loading fetch control inner
    const [ isLoading,          
            setIsLoading
    ]                       = useState(true);
    // Inner template Object state
    const [ obj,                
            setObj      
    ]                       = useState(blank_feedback_obj);   
    //  User Mentors 
    const [ userMentors,                
            setUserMentors, 
    ]                       = useState(null);   
    // Toast message display
    const { showToastMessage    

    }                       = useToastMessage(); 
    // Application Content List
    const [ applicationContentList,
            setApplicationContentList
    ]                       = useState(null);    
    // Development Stage List
    const [ developmentStageList,
            setDevelopmentStageList
    ]                       = useState(null);
    // Department List
    const [ departmentList,
            setDepartmentList
    ]                       = useState(null);    
    // Assignment List
    const [ assignmentList,
            setAssignmentList
    ]                       = useState(null);
    // Department + Assignment List
    const [ structuredList,
            setStructuredList
    ]                       = useState(null);            
    // Last feedback 
    const [ lastFeedBack,
            setLastFeedBack
    ]                       = useState(undefined);
    const elementRef        = useRef(null);
    const documentRef       = useRef(null);
    const [ isExporting, 
            setIsExporting
    ]                       = useState(false);
    const [ displayPrivate,
            SetDisplayPrivate
    ]                       = useState(false);
    const [ displayStage,
            SetDisplayStage
    ]                       = useState(true);

    useEditDraftAutoSave({
        draftKey: buildFeedBackDraftKey(obj),
        data:     obj,
        needSave: obj?.NeedSave,
    });

    const canEdit               = compareInitFinDate(getDateNow(), DateFromIsoString(Content?.header?.EndDate));

    const handleSave            = async (data) => {
        setIsLoading(true);
        let payload = await updateFeedBack(data);
        if (payload) {
            if (payload?.Status?.Code === 0) {
                showToastMessage({header: GetSystemLabel("Warning"), message: GetSystemLabel("SuccessUpdated")});
                clearEditDraft();
                if (obj.FeedBackId === 0) {
                    setObj(prev => {
                        return({
                            ...prev,
                            NeedSave: false,
                            FeedBackId : payload.Response.Content.FeedBackId,
                        });
                    });
                    SetContent(prev => {
                        return({
                            ...prev,
                            type: prev.last === 1 ? 1 : 3,
                        });
                    });
                }
                else {
                    setObj(prev => {
                        return({
                            ...prev,
                            NeedSave: false
                        });
                    });
                    SetContent(prev => {
                        return({
                            ...prev,
                            type: prev.last === 1 ? 1 : 3,
                        });
                    });
                }
            }
            else {
                ShowModal(<ModalContent Message={payload.Status.Message}/>);
            }
        }
        setIsLoading(false);
        setTimeout(() => {
            const container = document.getElementById("MainLayoutContainer");
            const element = elementRef.current;

            if (container && element) {
                const offsetTop = element.offsetTop;

                container.scrollTo({
                    top: offsetTop,
                    behavior: "smooth"
                });
            }
        }, 100);
    };
    const handleExit            = async () => {
        SetContent(prev => {
            return({
                ...prev,
                type: prev.last === 1 ? 1 : 3,
            });
        });
    };
    const fetchDependencies     = async () => {
        try {
            setIsLoading(true);
            const payloadDepartment = await getDepartmentList({StatusIds:[]});
            if (payloadDepartment) {
                if (payloadDepartment?.Status?.Code === 0) {
                    if (payloadDepartment?.Response?.Content) {
                        setDepartmentList(payloadDepartment?.Response?.Content);
                    }
                }
                else {
                    ShowModal(<ModalContent Message={payloadDepartment.Status.Message}/>);
                }
            }  
            const payloadAssignment = await getAssignmentList({StatusIds:[]});
            if (payloadAssignment) {
                if (payloadAssignment?.Status?.Code === 0) {
                    if (payloadAssignment?.Response?.Content) {
                        setAssignmentList(payloadAssignment?.Response?.Content);
                    }
                }
                else {
                    ShowModal(<ModalContent Message={payloadAssignment.Status.Message}/>);
                }
            }  
            const payloadStructured = await getDepartmentAssignmentList({StatusIds:[]});
            if (payloadStructured) {
                if (payloadStructured?.Status?.Code === 0) {
                    if (payloadStructured?.Response?.Content) {
                        setStructuredList(payloadStructured?.Response?.Content);
                    }
                }
                else {
                    ShowModal(<ModalContent Message={payloadStructured.Status.Message}/>);
                }
            }                                    
            const payloadDevStage = await getDevelopmentStageList(SearchStatus);
            if (payloadDevStage) {
                if (payloadDevStage?.Status?.Code === 0) {
                    if (payloadDevStage?.Response?.Content) {
                        setDevelopmentStageList(payloadDevStage?.Response?.Content);
                    }
                }
                else {
                    ShowModal(<ModalContent Message={payloadDevStage.Status.Message}/>);
                }
            }
            const payloadAppContent = await getApplicationContentList(SearchStatus);
            if (payloadAppContent) {
                if (payloadAppContent?.Status?.Code === 0) {
                    if (payloadAppContent?.Response?.Content) {
                        setApplicationContentList(payloadAppContent?.Response?.Content);
                    }
                }
                else {
                    ShowModal(<ModalContent Message={payloadAppContent.Status.Message}/>);
                }
            }  
            const payloadMentors = await getUserMentorsByID(Content?.body);
            if (payloadMentors) {
                if (payloadMentors?.Status?.Code === 0) {
                    if (payloadMentors?.Response?.Content) {
                        setUserMentors(payloadMentors?.Response?.Content);
                    }
                }
                else {
                    ShowModal(<ModalContent Message={payloadMentors.Status.Message}/>);
                }
            }
            const payloadHistory = await getLastUserFeedBack(Content?.body);
            if (payloadHistory) {
                if (payloadHistory?.Status?.Code === 0) {
                    if (payloadHistory?.Response?.Content) {
                        setLastFeedBack(payloadHistory?.Response?.Content);
                    }
                }
                else {
                    ShowModal(<ModalContent Message={payloadHistory.Status.Message}/>);
                }
            }
            setIsLoading(false);          
        } 
        catch (error) {
            setUserMentors([]);
            setIsLoading(false);
        }
    };
    const fetchData             = async (data) => {
        setIsLoading(true);
        try {            
            let payload = await getFeedBackByID(data);
            if (payload) {
                if (payload?.Status?.Code === 0) {
                    if (payload?.Response?.Content) {
                        let tmp = payload.Response.Content;
                        const draft = takeEditDraft(buildFeedBackDraftKey(tmp));
                        setObj(prev => {
                            return({
                                ...prev,
                                NeedSave                : false                  ,
                                CycleId                 : tmp.CycleId            ,
                                CyclePeriodId           : tmp.CyclePeriodId      ,
                                FeedBackId              : tmp.FeedBackId         ,
                                MentorId                : tmp.MentorId           ,
                                MenteeId                : tmp.MenteeId           ,
                                DepartmentId            : tmp.DepartmentId       ,
                                AssignmentId            : tmp.AssignmentId       ,
                                StatusId                : tmp.StatusId           ,
                                FillStatusId            : tmp.FillStatusId       ,
                                DevelopmentStageId      : tmp.DevelopmentStageId ,
                                EmployeeFeedBack        : tmp.EmployeeFeedBack   ,
                                ManagerFeedBack         : tmp.ManagerFeedBack    ,
                                DevelopmentPlan         : tmp.DevelopmentPlan    ,
                                NextSteps               : tmp.NextSteps          ,
                                FeedBackDate            : tmp.FeedBackDate       ,
                                ManagerPrivateNotes     : tmp.ManagerPrivateNotes,
                                ...(draft ?? {}),
                            })
                        });
                        setIsLoading(false);
                    }
                }
                else {
                    ShowModal(<ModalContent Message={payload.Status.Message}/>);
                    setIsLoading(false);
                }
            }
        } 
        catch (error) {
            setObj(blank_feedback_obj);
            setIsLoading(false);
        }
    };
    const handleDataSelection   = async (data) => {
        if (data?.FeedBackId === null) {
            let copy                = blank_feedback_obj;
            copy.CycleId            = data.CycleId;
            copy.CyclePeriodId      = data.CyclePeriodId;
            copy.MenteeId           = data.MenteeId;
            copy.DepartmentId       = data.DepartmentId;
            const draft = takeEditDraft(buildFeedBackDraftKey(copy));
            setObj({...copy, ...(draft ?? {})});
        }
        else {
            await fetchData(data);
        }
    };    
    const saveAction            = async () => {
        let tmp      = obj;
        let messages = [];
        if(obj?.FillStatusId === null) {
            tmp.FillStatusId = 0;
            setObj(prev => {
                return ({
                    ...prev,
                    FillStatusId: 0,
                })
            });
        }
        if (obj?.DepartmentId === 0 || obj?.DepartmentId === null || obj?.DepartmentId === undefined) {
            messages.push(GetBusinessLabel("WarningMessage10"));
        }
        if (obj?.AssignmentId === "" || obj?.AssignmentId === null || obj?.AssignmentId === undefined) {
            messages.push(GetBusinessLabel("WarningMessage9"));
        }        
        if (obj?.FeedBackDate === null || obj?.FeedBackDate === undefined) {
            messages.push(GetBusinessLabel("WarningMessage11"));
        }
        if (obj?.MentorId === 0 || obj?.MentorId === null || obj?.MentorId === undefined) {
            messages.push(GetBusinessLabel("WarningMessage12"));
        }                             
        if (obj?.DevelopmentStageId === 0 || obj?.DevelopmentStageId === null || obj?.DevelopmentStageId === undefined) {
            messages.push(GetBusinessLabel("WarningMessage13"));
        }      
        if (messages.length > 0) {
            ShowModal(<ModalContent Message={formatMessages({messageHeader: GetSystemLabel("Attention"), messageVector: messages})}/>);
        }
        else {
            await handleSave(tmp);
        }
    };
    const doneAction            = async () => {
        let tmp      = obj;
        let messages = [];
        if(obj?.FillStatusId === 0) {
            tmp.FillStatusId = 1;
            setObj(prev => {
                return ({
                    ...prev,
                    FillStatusId: 1,
                })
            });
        }
        if (obj?.DepartmentId === 0 || obj?.DepartmentId === null || obj?.DepartmentId === undefined) {
            messages.push(GetBusinessLabel("WarningMessage10"));
        }
        if (obj?.AssignmentId === "" || obj?.AssignmentId === null || obj?.AssignmentId === undefined) {
            messages.push(GetBusinessLabel("WarningMessage9"));
        }        
        if (obj?.FeedBackDate === null || obj?.FeedBackDate === undefined) {
            messages.push(GetBusinessLabel("WarningMessage11"));
        }
        if (obj?.MentorId === 0 || obj?.MentorId === null || obj?.MentorId === undefined) {
            messages.push(GetBusinessLabel("WarningMessage12"));
        }                     
        if (obj?.DevelopmentStageId === 0 || obj?.DevelopmentStageId === null || obj?.DevelopmentStageId === undefined) {
            messages.push(GetBusinessLabel("WarningMessage13"));
        }
        if (messages.length > 0) {
            ShowModal(<ModalContent Message={formatMessages({messageHeader: GetSystemLabel("Attention"), messageVector: messages})}/>);
        }
        else {
            await handleSave(tmp);    
        }
    };
    const exportAction          = async (includePrivate, includeStage) => {
        SetDisplayPrivate(includePrivate);
        SetDisplayStage(includeStage);
        setIsExporting(true);
    };

    useEffect(() => {
        if (Content) {
            fetchDependencies();
            handleDataSelection(Content?.body);
        } 
        else {
            fetchDependencies();
            setObj(blank_feedback_obj);
        }
    }, [Content]);
    
    return(
        isLoading? 
            <React.Fragment>
                <div className={Style.overflow_hidden}>
                    <div className={Style.py_5}>
                        <Spinner/>
                    </div>
                </div>
            </React.Fragment>
        :
            <React.Fragment>
                <div style={{display: 'flex', flexDirection: 'column' }}>
                    <FloatBtn 
                        Action={() => {
                            ShowSideContent({
                                component: AppContentList,
                                props: {
                                    ExternalDataSource: applicationContentList
                                },
                                overlay: true,
                            }); 
                        }} 
                        Label={{text: GetBusinessLabel("Script"), style: [Style.text_black].join(" ")}}
                        Position={{
                            style:      {   position: 'sticky',
                                            zIndex: 3,
                                            top: 0,
                                            marginLeft: 'auto',
                                            display: 'flex',
                                            flexDirection: 'column',    
                                            gap: '0.5rem',
                                            writingMode: "vertical-rl",
                                        }
                        }}
                        Button={{
                            class:      [   Style.d_flex,
                                            Style.align_items_center,
                                            Style.justify_content_center,
                                            Style.clickable,  
                                            Style.rounded_start_3, 
                                            Style.border, 
                                            Style.shadow_sm, 
                                            Style.info_bg, 
                                            Style.text_center, 
                                            Style.pop_item_animation_xe
                                        ].join(" "),
                            style:      {   width: '50px', height: '100px'}
                        }}
                    />        
                    <div className={[Style.mx_3].join(" ")}>
                        <FeedBackDocument 
                            ExternalRef={documentRef}
                            DisplayPrivate={displayPrivate}
                            DisplayStage={displayStage}
                            Save={isExporting}
                            OnDone={() => setIsExporting(false)}
                            History={lastFeedBack}
                            Content={Content?.body}
                            Object={obj}
                            SetObject={setObj}
                            StageList={developmentStageList}
                            UserMentorsList={userMentors}
                            DepartmentList={departmentList}
                            AssignmentList={assignmentList}
                            DepartmentAssignmentList={structuredList}
                        />
                        <FeedBackForm 
                            History={lastFeedBack}
                            Context={Content?.header}
                            Content={Content?.body}
                            Object={obj}
                            SetObject={setObj}
                            StageList={developmentStageList}
                            UserMentorsList={userMentors}
                            DepartmentList={departmentList}
                            AssignmentList={assignmentList}
                            DepartmentAssignmentList={structuredList}
                        />
                        <div ref={elementRef} className={Style.py_5}>
                            <FormControls 
                                Content={obj}
                                SetObject={setObj}
                                SaveAction={saveAction}
                                ExitAction={handleExit}
                                DoneAction={doneAction}
                                ExportAction={exportAction}
                                CanEdit={canEdit}
                            />                        
                        </div>
                    </div>      
                </div>  
            </React.Fragment>        
    );

};
const FeedBackHistory           = ({...setProps}) => {
    const { IsLoading,
            SetIsLoading,
            RowData,
            SearchText,
            SetSearchText,
            Content,
            SetContent,
            ShowModal,
            HideModal,
            ShowSideContent,
            HideSideContent,
            GetList,
    }                                            = setProps;
    // Mount State    
    const [isReady, setIsReady]                  = useState(false);
    
    const EditItem                  = useCallback((data) => {
        SetContent(prev => {
            return ({
                ...prev,
                type: 2,
                last: 3,
                header: data,
                body: data,
            });
        });
    }, [RowData, ShowSideContent, HideSideContent, ShowModal, HideModal]);

    const MenteeMeta                = (data) => {
        return (`${data?.MenteeFirstName} ${data?.MenteeLastName}`);
    };  
    const CycleMeta                 = (data) => {
        return (
            <React.Fragment>
                <span>                    
                    {`${data?.CycleYear}: ${data?.[`PeriodLabelName${GetAppLang()}`]} (${DisplayGridDate({value: data?.StartDate})} ${GetSystemLabel("until")} ${DisplayGridDate({value: data?.EndDate})})`} 
                </span>
            </React.Fragment>
        );
    };  
    const StatusFeedback            = (data) => {
        return(
            (data?.StatusId !== null) ? (
                (data?.FillStatusId === 0)  ? 
                    <span className={[Style.text_info, Style.fw_semibold].join(" ")}>                    
                        {GetSystemLabel("Open")}
                    </span>
                :
                (data?.FillStatusId === 1)  ? 
                    <span className={[Style.text_success, Style.fw_semibold].join(" ")}>                    
                        {GetSystemLabel("Finished")}
                    </span>
                :
                    <span className={[Style.text_warning, Style.fw_semibold].join(" ")}>
                        {GetSystemLabel("Pending")}
                    </span>
            )
            :
            <span className={[Style.text_danger, Style.fw_semibold].join(" ")}>
                {GetBusinessLabel("TableStateNotStarted")}
            </span>
        );
    };
    const FeedbackBtn               = (data) => {
        const canEdit = compareInitFinDate(getDateNow(), DateFromIsoString(data?.EndDate));
        return (
            data?.FeedBackId !== null ?   
                canEdit ?                         
                    <CustomBtn 
                        Action={() => EditItem(data)} 
                        Label={{text: GetSystemLabel("Edit"), style: [Style.text_body].join(" ")}}
                        Button={{style: [Style.clickable,  Style.rounded_3, Style.border, Style.shadow_sm, Style.vanilla_bg, Style.text_center, Style.pop_item_animation].join(" ")}}
                    />
                :
                    <CustomBtn 
                        Action={() => EditItem(data)} 
                        Label={{text: GetSystemLabel("See"), style: [Style.text_body].join(" ")}}
                        Button={{style: [Style.clickable,  Style.rounded_3, Style.border, Style.shadow_sm, Style.vanilla_bg, Style.text_center, Style.pop_item_animation].join(" ")}}
                    />
            :
                <CustomBtn 
                    Action={() => EditItem(data)} 
                    Label={{text: GetSystemLabel("Create"), style: [Style.text_ibody].join(" ")}}
                    Button={{style: [Style.clickable,  Style.rounded_3, Style.border, Style.shadow_sm, Style.info_bg, Style.text_center, Style.pop_item_animation].join(" ")}}
                />
        );
    };

    const columnDefs                = useMemo(() => [
        {
            headerName: GetSystemLabel("Actions"),
            marryChildren: true,
            children: [
                    {   hide: false,lockVisible: true,
                        cellRenderer: (params) => (                    
                            FeedbackBtn(params?.data)
                        ),
                        width: 100,
                        wrapText: true,
                        autoHeight: true,
                        cellStyle: { whiteSpace: "pre-line" },
                    }                     
            ]
        },     
        {   hide: false,lockVisible: true,
            headerName: GetBusinessLabel("FilledIn"),                 
            cellRenderer: (params) => (StatusFeedback(params?.data)),
            wrapText: true,
            autoHeight: true,
            flex: 0, 
            cellClass: [Style.table_text_left].join(" ")
        }, 
        { hide: false,lockVisible: true, headerName: GetBusinessLabel("Contributor"),                valueGetter: (params) => MenteeMeta(params.data), cellRenderer: (params) => (MenteeMeta(params?.data))            ,width: 350, filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,
        { hide: false,lockVisible: true, headerName: GetBusinessLabel("Hiring"),                cellRenderer: DisplayGridDate ,                 field: "HiredDateMentee"     ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,
        { hide: false,lockVisible: true, headerName: GetSystemLabel("Year"),                        cellRenderer: (params) => (CycleMeta(params?.data))             ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                
        {
            headerName: GetSystemLabel("Tracking"),
            marryChildren: true,
            children: [
                { hide: false,lockVisible: true, columnGroupShow: 'open',                  headerName: GetSystemLabel("CreatedBy"),                   field: "CreatedByName"              ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                
                { hide: false,lockVisible: true,                                           headerName: GetSystemLabel("UpdatedBy"),               field: "UpdatedByName"              ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                
                { hide: false,lockVisible: true, columnGroupShow: 'open',                  headerName: GetSystemLabel("CreatedDate"),            cellRenderer: DisplayGridDatetime, field: "CreatedDate"                ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                        
                {  hide: false,lockVisible: true,                                         headerName: GetSystemLabel("UpdatedDate"),        cellRenderer: DisplayGridDatetime, field: "UpdatedDate"                ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,
            ]
        },        
    ].filter(Boolean), [RowData, EditItem]);
    
    const gridContext               = useMemo(() => ({
        IsLoading,
        RowData,
        SetIsLoading,
        EditItem: EditItem,
    }), [RowData]);

    const  HandleFirstLoading       = (async () => {
            SetIsLoading(true);
            await GetList(Content?.header);  
            SetIsLoading(false);
    });
    useEffect(() => {
        if (!isReady) {
            setIsReady(true);
            HandleFirstLoading();
        }
    }, [Content, isReady]);
    
    return (
        <div className={Style.m_2}>
            <div className={[Style.row].join(" ")}>
                <div className={[Style.col_lg, Style.d_flex, Style.align_items_center, Style.justify_content_start].join(" ")}>
                    <p className={[Style.fs_6, Style.text_body, Style.fw_semibold, Style.me_2].join(" ")}>
                        {GetSystemLabel("History")} {GetSystemLabel("of")} : {Content?.header.MenteeFirstName} {Content?.header.MenteeLastName}
                    </p>
                    <RefreshBtn
                        Label={{text: GetSystemLabel("Update"), style: [Style.text_body, Style.fs_8, Style.mx_1].join(" ")}}
                        Button={{
                            class:      [   Style.d_flex,
                                            Style.align_items_center,
                                            Style.justify_content_center,
                                            Style.clickable,  
                                            Style.rounded_3, 
                                            Style.border, 
                                            Style.shadow_sm, 
                                            Style.vanilla_bg, 
                                            Style.text_center, 
                                            Style.pop_item_animation,
                                        ].join(" "),
                            style:      {}
                        }}
                        Action={() => {HandleFirstLoading();}}                         
                    />     
                    <CustomBtn 
                        Action={() => {SetContent(prev => {return({...prev,type: 1});})}}
                        Label={{text: GetSystemLabel("Return"), style: [Style.text_body, Style.fs_8, Style.mx_1].join(" ")}}
                        Button={{style: [Style.d_flex, Style.align_items_center, Style.justify_content_center, Style.clickable,  Style.rounded_3, Style.border, Style.shadow_sm, Style.vanilla_bg, Style.text_center, Style.pop_item_animation, Style.mx_3, Style.py_1].join(" ")}}
                    />                           
                </div>
            </div>
            {IsLoading? 
                <React.Fragment>
                    <div className={Style.overflow_hidden}>
                        <div className={Style.py_5}>
                            <Spinner/>
                        </div>
                    </div>
                </React.Fragment>
            :
                <React.Fragment>
                    <div className={Style.row}>
                        <div className={Style.col}>
                            <TableGrid
                                columnDefs={columnDefs}
                                rowData={RowData}
                                searchText={SearchText}
                                setSearchText={SetSearchText}
                                gridContext={gridContext}
                            />
                        </div>
                    </div>
                </React.Fragment>
            }
        </div>
    );
};
const FeedBackContent           = ({...setProps}) => {
    const { IsLoading,
            SetIsLoading,
            RowData,
            SearchText,
            SetSearchText,
            Content,
            SetContent,
            ShowModal,
            HideModal,
            ShowSideContent,
            HideSideContent,
            GetList,
    }                                            = setProps;
    // Mount State    
    const [isReady, setIsReady]                  = useState(false);

    function isValidCycle(d) {
        return ((d?.CycleYear !== null  && d?.CycleYear !== undefined) && 
                (d?.StartDate !== null  && d?.StartDate !== undefined) && 
                (d?.EndDate !== null    && d?.EndDate !== undefined)) ? true : false;
    }
    
    const EditItem                  = useCallback((data) => {
        SetContent(prev => {
            return ({
                ...prev,
                type: 2,
                last: 1,
                header: data,
                body: data,
            });
        });
    }, [RowData, ShowSideContent, HideSideContent, ShowModal, HideModal]);

    const MenteeMeta                = (data) => {
        //return (`${data?.MenteeFirstName} ${data?.MenteeLastName} (${data?.MenteeEmail})`);
        return (`${data?.MenteeFirstName} ${data?.MenteeLastName}`);
    };  
    const CycleMeta                 = (data) => {
        return (
            isValidCycle(data) ?
                <span>                    
                    {`${data?.CycleYear}: ${data?.[`PeriodLabelName${GetAppLang()}`]} (${DisplayGridDate({value: data?.StartDate})} ${GetSystemLabel("until")} ${DisplayGridDate({value: data?.EndDate})})`} 
                </span>
            :
                <span>             
                    {GetBusinessLabel("TableNoOpenCycle")}
                </span>
        );
    };  
    const StatusFeedback            = (data) => {
        return(
            isValidCycle(data)?
                    (data?.StatusId !== null) ? (
                        (data?.FillStatusId === 0)  ? 
                            <span className={[Style.text_info, Style.fw_semibold].join(" ")}>                    
                                {GetSystemLabel("Open")}
                            </span>
                        :
                        (data?.FillStatusId === 1)  ? 
                            <span className={[Style.text_success, Style.fw_semibold].join(" ")}>                    
                                {GetSystemLabel("Finished")}
                            </span>
                        :
                            <span className={[Style.text_warning, Style.fw_semibold].join(" ")}>
                                {GetSystemLabel("Pending")}
                            </span>
                    )
                    :
                    <span className={[Style.text_danger, Style.fw_semibold].join(" ")}>
                        {GetBusinessLabel("TableStateNotStarted")}
                    </span>
            :
                null
        );
    };
    const FeedbackBtn               = (data) => {
        const canEdit = compareInitFinDate(getDateNow(), DateFromIsoString(data?.EndDate));
        return (
            data?.CycleId !== null && data?.CyclePeriodId !== null ? 
                (data?.FeedBackId !== null ?
                        canEdit ?                         
                            <CustomBtn 
                                Action={() => EditItem(data)} 
                                Label={{text: GetSystemLabel("Edit"), style: [Style.text_body].join(" ")}}
                                Button={{style: [Style.clickable,  Style.rounded_3, Style.border, Style.shadow_sm, Style.vanilla_bg, Style.text_center, Style.pop_item_animation].join(" ")}}
                            />
                        :
                            <CustomBtn 
                                Action={() => EditItem(data)} 
                                Label={{text: GetSystemLabel("See"), style: [Style.text_body].join(" ")}}
                                Button={{style: [Style.clickable,  Style.rounded_3, Style.border, Style.shadow_sm, Style.vanilla_bg, Style.text_center, Style.pop_item_animation].join(" ")}}
                            />
                    :
                        <CustomBtn 
                            Action={() => EditItem(data)} 
                            Label={{text: GetSystemLabel("Create"), style: [Style.text_ibody].join(" ")}}
                            Button={{style: [Style.clickable,  Style.rounded_3, Style.border, Style.shadow_sm, Style.info_bg, Style.text_center, Style.pop_item_animation].join(" ")}}
                        />
                )
            :
                null
        );
    };
    const HistoryBtn                = (data) => {
        return (
            (data?.LastFeedBackDate !== null && data?.LastFeedBackDate !== undefined) ? 
                <CustomBtn 
                    Action={() => {
                        SetContent(prev => {
                            return ({
                                ...prev,
                                type: 3,
                                last: 3,
                                header: data,
                                body: data,
                            });
                        });
                    }} 
                    Label={{text: GetSystemLabel("History"), style: [Style.text_body].join(" ")}}
                    Button={{style: [Style.clickable,  Style.rounded_3, Style.border, Style.shadow_sm, Style.vanilla_bg, Style.text_center, Style.pop_item_animation].join(" ")}}
                />
            :
                null
        );
    };   

    const columnDefs                = useMemo(() => [
        {
            headerName: GetSystemLabel("Actions"),
            marryChildren: true,
            children: [
                    {   hide: false,lockVisible: true,
                        cellRenderer: (params) => (                    
                            FeedbackBtn(params?.data)
                        ),
                        width: 100,
                        wrapText: true,
                        autoHeight: true,
                        cellStyle: { whiteSpace: "pre-line" },
                    },        
                    {   hide: false,lockVisible: true,
                        cellRenderer: (params) => (                    
                            HistoryBtn(params?.data)
                        ),
                        width: 100,
                        wrapText: true,
                        autoHeight: true,
                        cellStyle: { whiteSpace: "pre-line" },
                    },                            
            ]
        },     
        {   hide: false,lockVisible: true,
            headerName: GetBusinessLabel("FilledIn"),                 
            cellRenderer: (params) => (StatusFeedback(params?.data)),
            wrapText: true,
            autoHeight: true,
            flex: 0, 
            cellClass: [Style.table_text_left].join(" ")
        },                    
        { hide: false,lockVisible: true, headerName: GetBusinessLabel("Contributor"),                valueGetter: (params) => MenteeMeta(params.data), cellRenderer: (params) => (MenteeMeta(params?.data))            ,width: 350, filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,
        { hide: false,lockVisible: true, headerName: GetBusinessLabel("Hiring"),                cellRenderer: DisplayGridDate ,                 field: "HiredDateMentee"     ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,
        { hide: false,lockVisible: true, headerName: GetSystemLabel("Year"),                        cellRenderer: (params) => (CycleMeta(params?.data))             ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                
        { hide: false,lockVisible: true, headerName: GetBusinessLabel("LastFeedBack"),            cellRenderer: DisplayGridDate ,                 field: "LastFeedBackDate"    ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,
        {   
            headerName: GetSystemLabel("Tracking"),
            marryChildren: true,
            children: [
                { hide: false,lockVisible: true, columnGroupShow: 'open',                  headerName: GetSystemLabel("CreatedBy"),                   field: "CreatedByName"              ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                
                { hide: false,lockVisible: true,                                          headerName: GetSystemLabel("UpdatedBy"),               field: "UpdatedByName"              ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                
                { hide: false,lockVisible: true, columnGroupShow: 'open',                  headerName: GetSystemLabel("CreatedDate"),            cellRenderer: DisplayGridDatetime, field: "CreatedDate"                ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,                                                                        
                { hide: false,lockVisible: true,                                          headerName: GetSystemLabel("UpdatedDate"),        cellRenderer: DisplayGridDatetime, field: "UpdatedDate"                ,filter: true , flex: 0, cellClass: [Style.table_text_left].join(" ")}    ,
            ]
        },        
    ].filter(Boolean), [RowData, EditItem]);
    
    const gridContext               = useMemo(() => ({
        IsLoading,
        RowData,
        SetIsLoading,
        EditItem: EditItem,
    }), [RowData]);

    const  HandleFirstLoading       = (async () => {
            SetIsLoading(true);
            await GetList();  
            SetIsLoading(false);
    });
    useEffect(() => {
        if (!isReady) {
            setIsReady(true);
            HandleFirstLoading();
        }
    }, [Content, isReady]);

    return (
        <div className={Style.my_2}>
            <div className={[Style.row].join(" ")}>
                <div className={[Style.col_lg, Style.d_flex, Style.align_items_center, Style.justify_content_start].join(" ")}>
                    <p className={[Style.fs_6, Style.text_body, Style.fw_semibold, Style.me_2].join(" ")}>                    
                        {GetBusinessLabel("FeedbackPageHeader")}
                    </p>
                    <RefreshBtn
                        Label={{text: GetSystemLabel("Update"), style: [Style.text_body, Style.fs_8, Style.mx_1].join(" ")}}
                        Button={{
                            class:      [   Style.d_flex,
                                            Style.align_items_center,
                                            Style.justify_content_center,
                                            Style.clickable,  
                                            Style.rounded_3, 
                                            Style.border, 
                                            Style.shadow_sm, 
                                            Style.vanilla_bg, 
                                            Style.text_center, 
                                            Style.pop_item_animation,
                                        ].join(" "),
                            style:      {}
                        }}
                        Action={GetList}                         
                    />
                </div>
            </div>
            {IsLoading? 
                <React.Fragment>
                    <div className={Style.overflow_hidden}>
                        <div className={Style.py_5}>
                            <Spinner/>
                        </div>
                    </div>
                </React.Fragment>
            :
                <React.Fragment>
                    <div className={Style.row}>
                        <div className={Style.col}>
                            <TableGrid
                                columnDefs={columnDefs}
                                rowData={RowData}
                                searchText={SearchText}
                                setSearchText={SetSearchText}
                                gridContext={gridContext}
                            />
                        </div>
                    </div>
                </React.Fragment>
            }
        </div>
    );
};

export const FeedBackPage       = () => {
    const [ mount,          setMount                ]       = useState(false);
    const { showSideContent, hideSideContent        }       = useSideContent();    
    const { showModal, hideModal                    }       = useModal();
    const [isLoading,   setIsLoading]                       = useState(true);
    const [rowData,     setRowData]                         = useState(null);      // State of rows def 
    const [searchText,  setSearchText]                      = useState('');      // Searched text state    
    const [content,     setContent]                         = useState({type: 1, last: 1, header: null, body: null});
    const [ access,     setAccess]                          = useState(false);

    const searchStatus = {StatusIds: [1]};

    const fetchFeedBackList             = async () => {
        try {
            let payload = await getFeedBackList();
            if (payload) {
                if (payload.Status.Code == 0) {
                    setRowData(payload.Response.Content);
                }
                else {
                    showModal(<ModalContent Message={payload.Status.Message}/>);
                }                        
            }
            else {
                showModal(<ModalContent Message={GetSystemLabel("ErrorGeneric")}/>);
            }
        }
        catch (error) {
            console.error(error);
        }
    };
    const fetchFeedBackHistoryList      = async (data) => {
        try {
            let payload = await getFeedBackHistoryList(data);
            if (payload) {
                if (payload.Status.Code == 0) {
                    setRowData(payload.Response.Content);
                }
                else {
                    showModal(<ModalContent Message={payload.Status.Message}/>);
                }                        
            }
            else {
                showModal(<ModalContent Message={GetSystemLabel("ErrorGeneric")}/>);
            }
        }
        catch (error) {
            console.error(error);
        }
    };
    
    useEffect(() => {
        if(!mount) {
            if(IsMentor()) {
                setAccess(true);
            }
            setMount(true);
        }
    }, [content]);

    return (
        access ?
            <div className={[Style.m_2, Style.pb_5].join(" ")}>
            <React.Fragment>
            {
                content?.type === 1? 
                    <React.Fragment>
                        <FeedBackContent 
                            SearchStatus={searchStatus}
                            ShowSideContent={showSideContent}
                            HideSideContent={hideSideContent}
                            ShowModal={showModal}
                            HideModal={hideModal}
                            IsLoading={isLoading}
                            SetIsLoading={setIsLoading}
                            RowData={rowData}
                            SetRowData={setRowData}
                            SearchText={searchText}
                            SetSearchText={setSearchText}
                            Content={content}
                            SetContent={setContent}
                            GetList={fetchFeedBackList}
                        />
                    </React.Fragment>
                :         
                content?.type === 2? 
                    <React.Fragment>
                        <FeedBackEdit 
                            SearchStatus={searchStatus}
                            ShowSideContent={showSideContent}
                            HideSideContent={hideSideContent}
                            ShowModal={showModal}
                            HideModal={hideModal}
                            IsLoading={isLoading}
                            SetIsLoading={setIsLoading}
                            Content={content}
                            SetContent={setContent}       
                            GetList={fetchFeedBackList}
                        />
                    </React.Fragment>
                :
                content?.type === 3? 
                    <React.Fragment>
                        <FeedBackHistory
                            SearchStatus={searchStatus}
                            ShowSideContent={showSideContent}
                            HideSideContent={hideSideContent}
                            ShowModal={showModal}
                            HideModal={hideModal}
                            IsLoading={isLoading}
                            SetIsLoading={setIsLoading}
                            RowData={rowData}
                            SetRowData={setRowData}
                            SearchText={searchText}
                            SetSearchText={setSearchText}
                            Content={content}
                            SetContent={setContent}
                            GetList={fetchFeedBackHistoryList}
                        />
                    </React.Fragment>                
                :                     
                    null
            }
            </React.Fragment>
                <div className={Style.py_2}/>
            </div>
        :
            <AccessDeniedContent/>
    );
};  